import { twMerge } from 'tailwind-merge';

type FileDataSourceRadioButtonTextProps = {
  text: string;
  classNames?: string;
};

export const FileDataSourceRadioButtonText: React.FC<FileDataSourceRadioButtonTextProps> = ({ text, classNames }) => {
  return <p className={twMerge('text-sm text-gray-700', classNames)}>{text}</p>;
};
